import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
 
import { LoginModule } from './login/login.module';
import { AdminLayoutComponent } from './pages/admin-layout.component';

const routes: Routes =[
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  }, {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './pages/admin-layout.module#AdminLayoutModule'
      }
    ]},
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

@NgModule({ 
  imports: [
    CommonModule,
    BrowserModule,
    LoginModule,
    RouterModule.forRoot(routes,{
       useHash: true
    })
  ],
  exports: [
    LoginModule,
  ],
})
export class AppRoutingModule { }
